interface IProps {
  className?: string
}

const ShareDownloadIcon = ({ className }: IProps) => {
  return (
    <svg
      width="15"
      height="15"
      className={className}
      viewBox="0 0 15 15"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="24 / basic / download">
        <path
          id="icon"
          fill="inherit"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.183 5.80806L8.12497 7.86612V1.25H6.87497V7.86612L4.81691 5.80806L3.93303 6.69194L7.49997 10.2589L11.0669 6.69194L10.183 5.80806ZM13.75 12.5V10H12.5V12.5H2.5V10H1.25V12.5C1.25 13.1904 1.80964 13.75 2.5 13.75H12.5C13.1904 13.75 13.75 13.1904 13.75 12.5Z"
        />
      </g>
    </svg>
  )
}

export { ShareDownloadIcon }
